import { useLingui } from '@lingui/react/macro';
import { fetchLocationMapImage } from 'modules/locations/store/actions';
import { selectCurrentLocation, selectProcess } from 'modules/locations/store/selectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useDispatchWithToast } from 'store/use-dispatch-with-toast';

interface UseFetchMapImageProps {
  locationId: number;
  width?: number;
  height?: number;
}

function useFetchMapImage(props: UseFetchMapImageProps) {
  const { t } = useLingui();
  const dispatchWithToast = useDispatchWithToast();
  const location = useSelector(selectCurrentLocation);
  const process = useSelector(selectProcess);
  const [isLoaded, setIsLoaded] = useState(false);

  const mapImage = location?.id === props.locationId ? location.mapImage : undefined;

  useEffect(() => {
    if (!mapImage && !isLoaded) {
      dispatchWithToast(fetchLocationMapImage({ locationId: props.locationId, width: props.width, height: props.height }), {
        error: t`Не удалось загрузить карту локации`,
      });
      setIsLoaded(true);
    }
  }, [dispatchWithToast, props.locationId, props.width, props.height, mapImage, isLoaded, t]);

  return {
    isLoaded,
    mapImage,
    isLoading: process.isProcessing && process.name === 'fetchLocationMapImage',
  };
}

export default useFetchMapImage;
